export class InvoiceTotal {

  amount: number;
  so: string;
  invoiceNo: string;
  companyName: string;

}



// WEBPACK FOOTER //
// ./src/app/core/models/invoice-total.ts